<template>
  <div class="metal_changed_pic">
    <img src="@/images/metal_j@2x.png">
    <div class="metal-text">
      <div class="templeName">
        <div class="textContainer">
          <span class="text" v-html="textInfo[0].textContent"></span>
        </div>
      </div>
      <div class="godName-first" style="font-size: 25px; line-height: 25px;">
        <div class="textContainer">
          <div>{{godNameText.text4}}</div><div>{{godNameText.text3}}</div><div>{{godNameText.text2}}</div><div>{{godNameText.text1}}</div><div>{{godNameText.text0}}</div>
        </div>
      </div>
      <div class="godName-last" style="font-size: 25px; line-height: 25px;">
        <div class="textContainer">
          <div>{{godNameText.text5}}</div><div>{{godNameText.text6}}</div><div>{{godNameText.text7}}</div><div>{{godNameText.text8}}</div><div>{{godNameText.text9}}</div>
        </div>
      </div>
      <div class="gift">
        <div class="textContainer">
          <span class="text" v-html="textInfo[1].textContent"></span>
        </div>
      </div>
      <div class="respect">
        <div class="textContainer">
          <span class="text" v-html="textInfo[2].textContent"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "../../commonMixin";
export default {
  // 桃心，五福
  name: "customizeMetalJ",
  mixins: [commonMixin],
  mounted() {
    this.calcEmFontsizeBase();
    this.controlWrap(0, this.customTextTempleName);
    this.controlFontsize(0, this.customTextTempleName);
    this.controlWrap(1, this.customTextGift);
    this.controlFontsize(1, this.customTextGift);
    this.controlWrap(2, this.customTextRespect);
    this.controlFontsize(2, this.customTextRespect);
    this.controlGodName();
  },
  data() {
    return {
      textInfo: [
        {
          name: "templeName",
          lineLimit: this.$store.getters.textSettingByComponentCode("J")
            .templeName.lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode("J")
            .templeName.textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode("J")
            .templeName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: ""
        },
        {
          name: "gift",
          lineLimit: this.$store.getters.textSettingByComponentCode("J").gift
            .lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode("J").gift
            .textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode("J").gift
            .maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: ""
        },
        {
          name: "respect",
          lineLimit: 1,
          textLimit: 2,
          maxFontsize: 15,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: ""
        }
      ],
      // godNameText:["","","","","","","","","",""],
      godNameText: {
        text0: "",
        text1: "",
        text2: "",
        text3: "",
        text4: "",
        text5: "",
        text6: "",
        text7: "",
        text8: "",
        text9: ""
      }
    };
  },
  watch: {
    customTextTempleName() {
      this.controlWrap(0, this.customTextTempleName);
      this.controlFontsize(0, this.customTextTempleName);
    },
    customTextGodName() {
      this.controlGodName();
    },
    customTextGift() {
      this.controlWrap(1, this.customTextGift);
      this.controlFontsize(1, this.customTextGift);
    },
    customTextRespect() {
      this.controlWrap(2, this.customTextRespect);
      this.controlFontsize(2, this.customTextRespect);
    }
  },
  methods: {
    controlGodName() {
      if (this.customTextGodName == "") {
        for (var j = 0; j < 10; j++) {
          this.godNameText[`text${j}`] = "";
        }
      }
      if (this.customTextGodName !== "") {
        let runNum = 0;
        if (this.customTextGodName.length <= 10) {
          runNum = this.customTextGodName.length;
        } else {
          runNum = 10;
        }
        //先清掉
        for (var k = 0; k < 10; k++) {
          this.godNameText[`text${k}`] = "";
        }
        let starNum = 5 - Math.ceil(runNum / 2);
        let textNum = 0;
        for (var i = starNum; i < starNum + runNum; i++) {
          this.godNameText[`text${i}`] = this.customTextGodName.substr(
            textNum,
            1
          );
          textNum = textNum + 1;
        }
      }
    }
  },
  computed: {
    //得到使用者動態輸入的值
    customTextTempleName() {
      return this.$store.getters.getCutomTempleName;
    },
    customTextGodName() {
      return this.$store.getters.getCutomGodName;
    },
    customTextGift() {
      return this.$store.getters.getCutomGift;
    },
    customTextRespect() {
      return this.$store.getters.getCutomRespect;
    }
  }
};
</script>

<style scoped lang="scss">
.templeName {
  height: 40px;
  width: 74px;
  border: 1px dashed $primaryLightColor;
  margin: 5px auto;
  display: flex;
  align-items: center;
  position: absolute;
  top: 11px;
  box-sizing: border-box;
  .textContainer {
    width: 74px;
    span {
      white-space: nowrap;
    }
  }
}
.godName-first {
  border: 1px dashed $primaryLightColor;
  display: inline-block;
  transform-origin: left center;
  position: absolute;
  top: 37px;
  right: -75px;
  transform: rotate(-50deg);
  box-sizing: border-box;
  .textContainer > div {
    transform: rotate(50deg);
    margin: 10px 0;
    width: 25px;
    height: 25px;
  }
}
.godName-last {
  border: 1px dashed $primaryLightColor;
  display: inline-block;
  transform-origin: right center;
  position: absolute;
  top: 39px;
  left: -71px;
  transform: rotate(46deg);
  width: 29px;
  box-sizing: border-box;
  .textContainer > div {
    transform: rotate(-46deg);
    margin: 10px 0;
    width: 25px;
    height: 25px;
  }
}
.gift {
  margin: 133px auto 0px 4px;
  border: 1px dashed $primaryLightColor;
  width: 73px;
  height: 38px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 74px;
    span {
      white-space: nowrap;
    }
  }
}
.respect {
  width: 46px;
  margin: 0 auto;
  position: absolute;
  bottom: -17px;
  left: 16px;
  @include phone {
    bottom: -16px;
  }
  .textContainer {
    width: 46px;
  }
}
.metal_changed_pic {
  position: relative;
  font-family: "Noto Serif TC";
  img {
    width: 100%;
  }
  .metal-text {
    position: absolute;
    top: 114px;
    left: 209px;
    color: $primaryLightColor;
    font-weight: 800;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 75px;
      left: 160px;
    }
    @include table {
      transform: scale(0.7);
      top: 54px;
      left: 134px;
    }
    @include phone {
      transform: scale(0.64);
      top: 44px;
      left: 120px;
    }
  }
  .metal-rotate-text {
    position: absolute;
    top: 114px;
    left: 209px;
    color: $primaryLightColor;
    font-weight: 800;
  }
}
</style>
